import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  UkUniqueNum,
  UkUniqueNumTwo,
  UkUniqueNumThree,
  UkUniqueNumFour,
} from "../../../app-constants";
import { Link } from "gatsby";

function Techsolution(props) {
  return (
    <div
      className="techsolution tech_uk tech_music_solution swift_process p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Ongoing Success with Our <span>Post-Launch Services</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="solution_box">
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNum}</div>
                <div className="item_txt">
                  <h5>App Store Optimization (ASO)</h5>
                  <p>
                    Our ASO service refines your app’s visibility through
                    keyword optimization, competitive analysis, and CRO. We
                    ensure your app ranks higher in search results and drives
                    increased downloads through data-driven tactics.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumTwo}</div>
                <div className="item_txt">
                  <h5>Performance Monitoring & Scaling</h5>
                  <p>
                    We continuously monitor app performance to identify
                    bottlenecks and optimize resource allocation. Our team
                    scales infrastructure to accommodate growing user bases,
                    ensure uninterrupted service, and boost performance.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumThree}</div>
                <div className="item_txt">
                  <h5>Feature Enhancements</h5>
                  <p>
                    We proactively assess user feedback and market trends to
                    deliver timely updates. Our agile approach allows us to
                    introduce new features and improvements seamlessly to
                    maintain the app’s competitive edge and user satisfaction.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumFour}</div>
                <div className="item_txt">
                  <h5>Security & Compliance Updates</h5>
                  <p>
                    Our experts maintain zero-trust security against emerging
                    threats. We implement regular security patches and ensure
                    compliance with evolving regulations to protect app and user
                    data from potential vulnerabilities.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Upscale Your Mobile App
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
